import SiteManager from '@/module/resourceCenter/page/siteManager.vue'
import DeviceManager from '@/module/resourceCenter/page/deviceManager.vue'
import CharginggunManager from '@/module/resourceCenter/page/charginggunManager.vue'
import RateManager from '@/module/resourceCenter/page/rateManager.vue'
import SimCardManager from '@/module/resourceCenter/page/simCardManager.vue'
import GunBoxManager from '@/module/resourceCenter/page/gunBoxManage.vue'
import HandProfit from '@/module/resourceCenter/page/handProfit/manage.vue'

// import RuleManager from '@/module/resourceCenter/page/ruleManager.vue'
import TypeManager from '@/module/resourceCenter/page/typeManager.vue'
import PersonPileManager from '@/module/resourceCenter/page/personPileManager.vue'
import CarManager from '@/module/resourceCenter/page/car/carManager.vue'
import AppointmentManager from './../page/appointmentManager/appointmentManager.vue'
import MeterAcquisitionManager from '@/module/resourceCenter/page/acquisitionManager.vue'
import layout from '@/layout/index'
import i18n from '@/lang/index'
// 导出配置的路由器
export default [{
  path: '/resourceCenter',
  component: layout,
  redirect: 'resourceCenter/siteManager',
  meta: {
    title: i18n.t('zi-yuan-zhong-xin'),
    icon: 'icon-ziyuan',
    perms: ['bee:res']
  },
  children: [
    {
      path: 'siteManager',
      component: SiteManager,
      meta: {
        title: i18n.t('chong-dian-zhan-guan-li-0'),
        icon: 'icon-changzhan',
        perms: ['bee:res:station']
      }
    },
    {
      path: 'handProfit',
      component: HandProfit,
      meta: {
        title: '手动分润',
        icon: 'icon-feishuaiguanli',
        perms: ['bee:res:handProfit']
      }
    },
    {
      path: 'deviceManager',
      component: DeviceManager,
      meta: {
        title: i18n.t('chong-dian-zhuang-guan-li-0'),
        icon: 'icon-shebei1',
        perms: ['bee:res:pile']
      }
    },
    {
      path: 'charginggunManager',
      component: CharginggunManager,
      meta: {
        title: i18n.t('chong-dian-qiang-guan-li-0'),
        icon: 'icon-chongdianqiang',
        perms: ['bee:res:gun']
      }
    },
    {
      path: 'rateManager',
      component: RateManager,
      meta: {
        title: i18n.t('fei-shuai-guan-li'),
        icon: 'icon-feishuaiguanli',
        perms: ['bee:res:rate:getRates']
      }
    },
    {
      path: 'gunBoxManager',
      component: GunBoxManager,
      meta: {
        title: i18n.t('xiang-bian-guan-li'),
        icon: 'icon-feishuaiguanli',
        perms: ['bee:res:gunBox']
      }
    },
    {
      path: 'simCardManager',
      component: SimCardManager,
      meta: {
        title: i18n.t('sim-ka-guan-li'),
        icon: 'icon-qia2',
        perms: ['bee:res:simCard']
      }
    },
    {
      path: 'typeManager',
      component: TypeManager,
      meta: {
        title: i18n.t('chong-dian-zhuang-xing-hao-guan-li'),
        icon: 'icon-xinghao1',
        perms: ['bee:res:pileType']
      }
    },
    // {
    //   path: 'personPileManager',
    //   component: PersonPileManager,
    //   meta: {
    //     title: '个人桩管理',
    //     icon: 'icon-qia2',
    //     perms: ['bee:member:group']
    //   }
    // },
{
      path: 'carManager',
      component: CarManager,
      meta: {
        title: i18n.t('che-liang-guan-li'),
        icon: 'icon-cheliang',
        perms: ['bee:res:car']
      }
    },{
      path: 'appointmentManager',
      component: AppointmentManager,
      meta: {
        title: i18n.t('yu-yue-guan-li'),
        icon: 'icon-yuyue',
        perms: ['bee:res:appoint']
      }
    },
    {
      path: 'meterConfigurationManager',
      component: () => import("@/module/resourceCenter/page/meterConfigurationManager.vue"),
      meta: {icon: 'icon-caozuo', title: i18n.t('chao-biao-pei-zhi-0'),perms:['bee:res:ims']}
    },
    {
      path: 'meterAcquisitionManager',
      component: MeterAcquisitionManager,
      meta: {
        title: i18n.t('chao-biao-zhong-duan'), icon: 'icon-cheliang', perms: ['bee:res:terminal']
      }
    },
    {
      path: 'paramMeter',
      component: () => import("@/module/resourceCenter/page/meterManager.vue"),
      meta: {icon: 'icon-caozuo', title: i18n.t('dian-biao-guan-li-0'),perms:['bee:res:meter']}
    },
    {
     path: 'pileDateQueManager',
     component: () => import("@/module/resourceCenter/page/pileDateQueManager.vue"),
     meta: {icon: 'icon-caozuo', title: i18n.t('cai-ji-tong-ji'),perms:['bee:res:pileQue']}
    },
    {
     path: 'businessOperatorManager',
     component: () => import("@/module/resourceCenter/page/businessOperatorManager.vue"),
     meta: {icon: 'icon-caozuo', title: i18n.t('ying-ye-shang-guan-li-0'),perms:['bee:res:business']}
    },
    {
     path: 'simRenewManager',
     component: () => import("@/module/resourceCenter/page/simRenewManager.vue"),
     meta: {icon: 'icon-caozuo', title: i18n.t('sim-zhi-fu-guan-li'),perms:['bee:res:simCard:getSimCardLogs']}
    },
    {
     path: 'dynamicImagePositionManager',
     component: () => import("@/module/resourceCenter/page/dynamicImagePositionManager.vue"),
     meta: {icon: 'icon-caozuo', title: i18n.t('tu-wei-guan-li-0'),perms:['bee:res:dynamicImagePosition']}
    },

    {
     path: 'dynamicImageManager',
     component: () => import("@/module/resourceCenter/page/dynamicImage.vue"),
     meta: {icon: 'icon-caozuo', title: i18n.t('tu-pian-she-zhi'),perms:['bee:res:dynamicImage']}
    },
    // {
    //   path: 'meterAcquisitionManager',
    //   component: () => import("@/module/resourceCenter/page/acquisitionManager.vue"),
    //   meta: {icon: 'icon-caozuo', title: '抄表终端采集',perms:['bee:res:terminal']}
    // },
  ]
}]



// WEBPACK FOOTER //
// ./src/module/resourceCenter/router/index.js